import React from "react";
import PropTypes from "prop-types";
import FileSaver from "file-saver";

class DownloadGpx extends React.Component {
  state = {
    isLoading: true,
    error: false,
    errorMessage: ""
  };

  componentDidMount = () => {
    const { geojson } = this.props;

    const { type } = geojson;
    const features = [...geojson.features];
    const correctGeojson = { type, features };

    // console.log("correctGeojson", correctGeojson);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(correctGeojson)
    };

    // fetch("http://localhost:5000/togpx", options)
    fetch("https://conamo-api.herokuapp.com/togpx", options)
      .then(function(response) {
        if (!response.ok) {
          throw Error(response.status);
        }
        return response;
      })
      .then(this.saveFile)
      .catch(this.handleError);
    // .catch(console.error);
  };

  saveFile = response => {
    response.text().then(text => {
      var blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, "mijn_route.gpx");
      this.setState({ isLoading: false });
    });
  };

  handleError = () => {
    const errorMessage =
      "Er is een fout opgetreden bij het ophalen van de gpx. Probeer het later nog eens.";
    this.setState({ error: true, errorMessage, isLoading: false });
  };

  render() {
    return this.props.render(this.state);
  }
}

DownloadGpx.propTypes = {
  render: PropTypes.func.isRequired,
  geojson: PropTypes.object.isRequired
};

export default DownloadGpx;



// WEBPACK FOOTER //
// ./src/NewRoute/components/DownloadGpx.js